import { BASE_URL, WORKSHOP_INVITATION2, WORKSHOPS_GROUP } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IWorkshopsGroup, IWorkshopsGroupInput } from "models/workshopsgroup";


export async function getWorkshopsGroups(params: string = ""): Promise<IWorkshopsGroup[]> {
  const response = await axios.get(BASE_URL + WORKSHOPS_GROUP + params);
  return response.data;
}
export async function addWorkshopsGroup(data: IWorkshopsGroupInput) {
  const response = await axios.post(BASE_URL + WORKSHOPS_GROUP, data);
  return response.data;
}
export async function editWorkshopsGroup(data: IWorkshopsGroupInput, id: string) {
  const response = await axios.patch(BASE_URL + WORKSHOPS_GROUP + "/" + id, data);
  return response.data;
}

export async function deleteWorkshopsGroup(id: string) {
  
  const response = await axios.delete(BASE_URL + WORKSHOPS_GROUP + "/" + id);
  return response.data;
}

export async function deleteWorkshopsGroupInvitation(id: string) {
  
  const response = await axios.delete(BASE_URL + WORKSHOP_INVITATION2 + "/" + id);
  return response.data;
}

export const WorkshopCells: HeadCell[] = [   
  {
    id: "workshopTitle",
    numeric: false,
    disablePadding: false,
    label: "T_title",
  },
  {
    id: "providers",
    numeric: false,
    disablePadding: false,
    label: "T_provider",
  },
  {
    id: "numberOfWorkshops",
    numeric: false,
    disablePadding: false,
    label: "T_number_workshops",
  },
  {
    id: "createdOn",
    numeric: false,
    disablePadding: false,
    label: "T_created_on",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
